/* eslint-disable react-hooks/exhaustive-deps */
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React from 'react';
import { useMemo } from 'react';
import { Box, Card, CardContent, Grid, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import VoucherDetails from 'modules/expenses/vouchers/details/voucherDetails.component';

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute',
    zIndex: '1 !important'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px',
    paddingLeft: '50px',
    paddingRight: '50px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
}));

const VoucherPreviewCard = props => {
  const { voucherDetails, expenseCodes, authorizationDetails, clients, enumerations} = props;

  const classes = useStyles();

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });
    const clientsArray = useMemo(() => (Array.isArray(clients) ? clients : Object.values(clients ?? {})), [clients]);
  
    const normalizedClients = useMemo(
      () =>
        (clientsArray ?? []).map(c => ({
          clientRecordId: c.clientRecordId ?? c.id ?? c.clientId,
          legalName: c.legalName ?? c.clientName ?? c.description ?? '',
          id: c.clientRecordId ?? c.id ?? c.clientId,
          description: c.legalName ?? c.clientName ?? c.description ?? '',
          clientId: c.clientRecordId ?? c.id ?? c.clientId,
          clientName: c.legalName ?? c.clientName ?? c.description ?? ''
        })),
      [clientsArray]
    );

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.card} sx={{ marginTop: '10px' }}>
        <Box>
          <CardContent className={classes.cardContainer}>
            <div className="row justify-space-between">
              <Box sx={{ display: 'flex' }}>
                <Tooltip title="Estimates" key="Estimates" placement="right">
                  <FontAwesomeIcon icon={['fas', 'file-contract']} size="2x" />
                </Tooltip>
                <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                  Voucher Preview
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" sx={{ color: '#41B7C0', fontWeight: 500, fontSize: '1rem', paddingTop: '20px' }}>
                  View Attachment
                </Typography>
              </Box>
            </div>
          </CardContent>
          <CardContent sx={{ padding: '10px', marginLeft: '10px', paddingTop: '0px' }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                  <Box>
                      <VoucherDetails
                        voucherDetail={voucherDetails}
                        voucherId={voucherDetails?.voucherId}
                        expenseCodes={expenseCodes}
                        enumerations={enumerations.allEnums || []}
                        banks={authorizationDetails.bankAccounts}
                        addresses={authorizationDetails.addresses}
                        payeeDetails={authorizationDetails}
                        clients={normalizedClients || []}
                        history={props.history}
                        location={props.location}
                        match={props.match}
                        isFeeVoucher
                        isReadOnly={true}
                    />
                  </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </Card>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const {
    authorizationDetails,
    isLoading,
    currentAuthId,
    expenseCodes,
    brokerAgents,
    vendors,
    inspectors,
    titleReps
  } = state.authorizations;
  const { unmappedClients } = state.clients;
  return {
    authorizationDetails,
    isLoading,
    currentAuthId,
    expenseCodes,
    unmappedClients,
    brokerAgents,
    vendors,
    inspectors,
    titleReps
  };
};

export default compose(
  connect(mapStateToProps, {
    showToast
  })
)(VoucherPreviewCard);
